import script from "./groupnested.vue?vue&type=script&lang=ts&setup=true"
export * from "./groupnested.vue?vue&type=script&lang=ts&setup=true"

import "./groupnested.vue?vue&type=style&index=0&id=7568748c&lang=scss&scoped=true"
import "./groupnested.vue?vue&type=style&index=1&id=7568748c&lang=scss"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7568748c"]])

export default __exports__